import { useTranslation } from 'react-i18next';
import { Logo } from '../Brand/Logo.js';

export function LoadingScreen() {
  const { t } = useTranslation();
  return (
    <div
      className="flex min-h-[40vh] items-center justify-center"
      role="status"
      aria-label={t('common.loading')}
    >
      <Logo showBadge={false} className="animate-loading-pulse h-12" />
    </div>
  );
}
